import { data } from 'autoprefixer';
import axios from 'axios';
const sign_in = (username, password) => {
    const data = {
        email: username,
        password: password,
        ml: ''
    }
    let url= process.env.REACT_APP_API_SERVER_HOST  
    +'/auth/signin'
    return axios.post(url,data).then((response) => {
        return response.data
    }).catch(error => {
        if (error.response?.status === 403 && error.response?.data?.message === "Publisher account is disabled") {
            return {
                status: 403,
                ...error.response.data
            };
        }
        return { data: [] }
    })
}

const select_account = (account, password) => {
    const data = {
        password,
        account_type: account.account_type,
        pubid: account.pubid,
        publisher_users_id: account.publisher_users_id
    };
    const url = process.env.REACT_APP_API_SERVER_HOST + '/auth/signin/select-account';

    return axios.post(url, data, {
        headers: { "access-token": localStorage.getItem("access-token") }
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        return error?.response?.data || { success: false, message: 'Unable to sign in to the selected account.' };
    });
}

const verifyMFAToken = (auth_token, user_id, role_id) => {
    const data = {
      auth_token: auth_token,
      user_id: user_id,
      role_id: role_id,
    };
    let url=process.env.REACT_APP_API_SERVER_HOST + "/auth/mfa/verify"
    return axios
      .get(url, {
        params: data,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (error.response.status == 400) {
          return error.response.data;
        } else {
          return [];
        }
      });
  };
const getInitials = (pubid) => {
  let header = {
    headers: {
"access-token": localStorage.getItem('access-token'),
      pubid: localStorage.getItem("pub_id"),
      role_id: localStorage.getItem("role_id"),
    },
  };
  let url = process.env.REACT_APP_API_SERVER_HOST + "/publisher/" + pubid
  return axios
    .get(url, header)
    .then((response) => response.data && response.data)
    .catch((e) => false);
};
export const service = {
    sign_in,
    select_account,
    verifyMFAToken,
    getInitials
}
